const breakpoints = {
  forPhoneOnly: 599,
  forTabletVerticalUp: 600,
  forTabletVerticalDown: 899,
  forTabletHorizontalUp: 900,
  forTabletHorizontalDown: 1199,
  forDesktopUp: 1200,
  forDesktopDown: 1799,
  forBigDesktopUp: 1800,
};

export default breakpoints;
